<!-- @format -->

<template>
	<el-form label-position="left" label-width="auto" size="small" class="setting-container-field">
		<pc-collapse v-model="activeNames">
			<pc-collapse-item
				v-for="item in baseConfigStore.getFormAttributeWidget()"
				:key="item.title"
				:title="item.title"
				:name="item.title"
			>
				<template v-for="key in item.props" :key="key">
					<widget-form-item
						v-model="formAttribute[key]"
						v-bind="getPropEditor(key).formItemProps"
						:type="getPropEditor(key).type"
						:pc-props="getPropEditor(key).pcProps"
					/>
				</template>
			</pc-collapse-item>
		</pc-collapse>
	</el-form>
</template>

<script setup lang="ts">
	import { useBaseConfigStoreWithOut } from '../../../config';
	import { useDragStoreWithOut } from '../../../store';
	import WidgetFormItem from '../../../components/widget-form-item/index.vue';
	import type { WidgetConfig } from '../../../types';
	import { PcCollapse, PcCollapseItem } from '@/components';

	const name = inject<string>('name');

	const dragStore = useDragStoreWithOut(name);
	const baseConfigStore = useBaseConfigStoreWithOut(name);

	const activeNames = ref(baseConfigStore.getFormAttributeWidget().map((i) => i.title));

	const formAttribute = computed({
		get() {
			return dragStore.formAttribute;
		},
		set(val) {
			dragStore.setState({ formAttribute: val });
		},
	});

	const getPropEditor = (key: string): WidgetConfig => {
		return baseConfigStore.FORM_ATTRIBUTE[key];
	};
</script>

<style scoped></style>
